import { isValid } from 'date-fns'

export const formatarData = (data: Date) => {
  return isValid(new Date(data)) ? new Intl.DateTimeFormat('pt-BR').format(new Date(data)) : '-'
}

export const parsePorcentagem = (valor: string) => {
  return parseFloat(valor) * 100
}
